module.exports = __webpack_public_path__ + "img/1798bfd.jpg";